var $ = Object.defineProperty;
var N = (t, r, s) => r in t ? $(t, r, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[r] = s;
var y = (t, r, s) => (N(t, typeof r != "symbol" ? r + "" : r, s), s);
const x = {
  stringify: (t) => t,
  parse: (t) => t
}, C = {
  stringify: (t) => `${t}`,
  parse: (t) => parseFloat(t)
}, J = {
  stringify: (t) => t ? "true" : "false",
  parse: (t) => /^[ty1-9]/i.test(t)
}, T = {
  stringify: (t) => JSON.stringify(t),
  parse: (t) => {
    if (t.trim().length === 0)
      return [];
    let r;
    try {
      r = JSON.parse(t);
    } catch {
      return t.trim().split(",");
    }
    if (!Array.isArray(r))
      throw new Error(`Failed to parse attribute value as an array: ${r}`);
    return r;
  }
}, V = {
  stringify: (t) => t.name,
  parse: (t, r) => {
    const s = (() => {
      if (typeof window < "u" && t in window)
        return window[t];
      if (typeof global < "u" && t in global)
        return global[t];
    })();
    return typeof s == "function" ? s.bind(r) : void 0;
  }
}, P = {
  stringify: (t) => JSON.stringify(t),
  parse: (t) => JSON.parse(t)
}, E = {}, A = {
  string: x,
  number: C,
  boolean: J,
  array: T,
  function: V,
  json: P,
  object: E
}, h = Symbol.for("r2wc.render"), d = Symbol.for("r2wc.connected"), p = Symbol.for("r2wc.context"), o = Symbol.for("r2wc.props");
function z(t, r, s) {
  var O, j, k;
  r.props || (r.props = t.propTypes ? Object.keys(t.propTypes) : []);
  const g = (Array.isArray(r.props) ? r.props.slice() : Object.keys(r.props)).filter((e) => e !== "container"), u = {}, m = {}, w = {};
  for (const e of g) {
    u[e] = Array.isArray(r.props) ? "string" : r.props[e];
    const f = F(e);
    m[e] = f, w[f] = e;
  }
  class S extends HTMLElement {
    constructor() {
      super();
      y(this, O, !0);
      y(this, j);
      y(this, k, {});
      y(this, "container");
      r.shadow ? this.container = this.attachShadow({
        mode: r.shadow
      }) : this.container = this, this[o].container = this.container;
      for (const c of g) {
        const l = m[c], i = this.getAttribute(l), n = u[c], a = A[n];
        i && (a != null && a.parse) && (this[o][c] = a.parse(i, this));
      }
    }
    static get observedAttributes() {
      return Object.keys(w);
    }
    connectedCallback() {
      this[d] = !0, this[h]();
    }
    disconnectedCallback() {
      this[d] = !1, this[p] && s.unmount(this[p]), delete this[p];
    }
    attributeChangedCallback(c, l, i) {
      const n = w[c], a = u[n], b = A[a];
      n in u && (b != null && b.parse) && (this[o][n] = b.parse(i, this), this[h]());
    }
    [(O = d, j = p, k = o, h)]() {
      this[d] && (this[p] ? s.update(this[p], this[o]) : this[p] = s.mount(
        this.container,
        t,
        this[o]
      ));
    }
  }
  for (const e of g) {
    const f = m[e], c = u[e];
    Object.defineProperty(S.prototype, e, {
      enumerable: !0,
      configurable: !0,
      get() {
        return this[o][e];
      },
      set(l) {
        this[o][e] = l;
        const i = A[c];
        if (i != null && i.stringify) {
          const n = i.stringify(l);
          this.getAttribute(f) !== n && this.setAttribute(f, n);
        } else
          this[h]();
      }
    });
  }
  return S;
}
function F(t = "") {
  return t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
export {
  z as default
};
